import { useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { HomePage } from './features/home/HomePage'
import { GeneratorPage } from './features/generators/GeneratorPage'
import { ProjectsPage } from './features/projects/ProjectsPage'
import DataDebug from './pages/DataDebug'
import StorageMigration from './pages/StorageMigration'
import { useCustomValuesStore } from './stores/customValuesStore'
import { useSettingsStore } from './stores/settingsStore'
// デバッグ用のimportは一旦コメントアウト
// 各関数が自動実行される問題を解決するため
/*
import { emergencyRestore } from './utils/emergencyRestore'
import { checkApiKeyStorage } from './utils/checkApiKeyStorage'
import { checkPlotData } from './utils/checkPlotData'
import { verifyPlotMigration } from './utils/verifyMigration'
import { testIndexedDBOnly, restorePlotLocalStorage } from './utils/testIndexedDBOnly'
import { cleanupTestBackups, listAllBackups } from './utils/cleanupBackups'
*/

function App() {
  const initCustomValues = useCustomValuesStore(state => state.init)
  const initSettings = useSettingsStore(state => state.init)
  
  useEffect(() => {
    // IndexedDBを初期化
    initCustomValues()
    initSettings()
    
    // 緊急復旧関数をグローバルに公開（一旦コメントアウト）
    // 各関数が自動実行される問題を調査中
    /*
    if (typeof window !== 'undefined') {
      (window as any).emergencyRestore = emergencyRestore
      (window as any).checkApiKeyStorage = checkApiKeyStorage
      (window as any).checkPlotData = checkPlotData
      (window as any).verifyPlotMigration = verifyPlotMigration
      (window as any).testIndexedDBOnly = testIndexedDBOnly
      (window as any).restorePlotLocalStorage = restorePlotLocalStorage
      (window as any).cleanupTestBackups = cleanupTestBackups
      (window as any).listAllBackups = listAllBackups
    }
    */
  }, [])
  
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/generator/:type" element={<GeneratorPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/debug" element={<DataDebug />} />
          <Route path="/migration" element={<StorageMigration />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App